import { render, staticRenderFns } from "./blessingDragon.vue?vue&type=template&id=4513860f&scoped=true"
import script from "./blessingDragon.vue?vue&type=script&lang=js"
export * from "./blessingDragon.vue?vue&type=script&lang=js"
import style0 from "./blessingDragon.vue?vue&type=style&index=0&id=4513860f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4513860f",
  null
  
)

export default component.exports